<template>
    <el-form :model="form" :rules="rules" ref="form" class="login">
        <el-row>
            <el-col :span="12">登录</el-col>
            <el-col :span="12"><el-link type="primary" href="#/register" style="float: right">注册</el-link></el-col>
        </el-row>
        <el-divider></el-divider>
        <el-form-item prop="Phone">
            <el-input placeholder="手机号登录" v-model="form.Phone" maxlength="11" autocomplete="off">
                <template slot="prepend">+86</template>
            </el-input>
        </el-form-item>

        <el-form-item prop="Code">
            <el-input placeholder="请输入短信验证码" maxlength="6" v-model="form.Code" @blur="isCode" style="width: 150px; margin-right: 10px"></el-input>
            <el-button @click="sendCode" :disabled="countdown >= 0" element-loading-spinner="el-icon-loading" type="primary" width="100%">{{ CodeButton }}</el-button>
        </el-form-item>

        <el-row>
            <el-col :span="12"><el-link href="#/login">密码登录</el-link></el-col>
            <el-col :span="12"><el-link type="primary" href="#/forgetpassword" style="float: right">忘记密码</el-link></el-col>
        </el-row>
        <el-form-item style="margin-top: 40px">
            <el-button type="primary" @click="login" style="width: 100%">登录</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
export default {
    data() {
        return {
            //定义form
            form: {
                Phone: '',
                Code: '',
            },
            //定义验证
            rules: {
                Phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
                Code: [ { required: true, message: "请输入验证码", trigger: "blur", }],
            },
            CodeButton: "获取验证码",
            countdown: -1,
        }
    },
    created() {


    },
    methods: {
        login() {
            //验证
            this.$refs.form.validate((valid) => {
                if (valid) {

                    this.Data.Users.LoginCode(this.form.Phone, this.form.Code).then(res => {

                        if (res.code == 0) {
                            this.$router.push('/app/list');
                        }
                        else {
                            this.$message.error(res.message);
                        }
                    })
                }
            })
        },
        //60s倒计时实现逻辑
        countDown() {
            this.countdown = 60;
            let seti = setInterval(() => {

                this.countdown--;
                if (this.countdown >= 0) {
                    this.CodeButton = this.countdown + "s后 重新发送";
                }
                else {
                    this.CodeButton = '获取验证码';
                    clearInterval(seti);
                }
            }, 1000);
        },
        //获取验证码
        sendCode() {
            if (this.form.Phone) {

                this.Data.Users.SendCode(this.form.Phone, 2).then(res => {
                    if (res.code == 0) this.countDown();
                    else this.$message({ type: "error", message: res.message });
                })

            }
        },
        //验证码是否可用
        isCode() {
            if (this.form.Code) {
                this.Data.Users.IsCode(this.form.Phone, this.form.Code, 2).then((res) => {
                    if (res.code == 0) {
                        if (!res.data) {
                            this.$message({ type: "error", message: "验证码错误！" });
                        }
                    }
                });
            }
        },
    }
};
</script>

<style >
.login {
    -webkit-border-radius: 5px;
    border-radius: 5px;
    margin: 180px auto;
    max-width: 350px;
    min-width: 260px;
    padding: 35px 35px 15px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
}
.login .title {
    text-align: center;
}
.login .password {
    margin-bottom: 15px;
}
.login .remember {
    margin-bottom: 5px;
}
</style>